import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14 15.5V5.955C14 1.864 12.667.5 8.667.5H2v15zM4.999 7.032h5.998v-1.4H5zm0 3.332h5.998v-1.4H5z"
                fill="currentColor"
            />
        </g>
    </svg>
));
DocumentFilledSize16Glyph.displayName = 'DocumentFilledSize16Glyph';
